import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import * as actions from '../actions';
import './style.css';

class Home extends Component {
  constructor(props) {
    super(props);

    this.renderButton = this.renderButton.bind(this);
    this.renderReLoginError = this.renderReLoginError.bind(this);
  }

  renderButton() {
    const { auth, error } = this.props;
    if (auth && !error) {
      return (
        <Link to="/dashboard" onClick={this.props.resetErrors}>
          <button className="btn z-depth-3 home__button">
            Dashboard
          </button>
        </Link>
      )
    }

    return <a className="white-text" href="/auth/google">
      <button className="btn z-depth-3 home__button">Get started</button>
    </a>
  }

  renderReLoginError() {
    if (this.props.error) {
      return (
        <div className="col s12" style={{textDecoration: 'underline'}}>
          Your session expired. Please login again below.
        </div>
      )
    }

    return null;
  }

  render() {
    const publicUrl = process.env.PUBLIC_URL;

    return (
      <div className="container">
        <div className="row">
          <div className="center">
            {this.renderReLoginError()}
            <div className="home__top-section">
              <h2 className="col s12 home__header">
                The on-page SEO platform made for you
              </h2>
              <p style={{fontSize: '1.5em', color: '#737272'}}>
                Optimize your website with everything you need on one screen. Dominate the SERPs. Page Outil has you covered.
              </p>
            </div>

            {this.renderButton()}
          </div>

          <div className="home__features">
            <div className="col l4 m4 s12">
              <img src={`${publicUrl}assets/page-by-page-optimization.png`}
                  alt="page by page gsc analysis"
                  width="300"
                  height="179"
                  className="responsive-img"/>
              <p className="promo-caption">Page by page analysis</p>
              <p>Easily find the keywords you're ranking for on a page-by-page basis. No more having to take 2-3 steps in applying filters.</p>
            </div>
            <div className="col l4 m4 s12">
              <img src={`${publicUrl}assets/deep-dive-keyword-analysis.png`}
                  alt="keyword density, frequency deep dive"
                  width="305"
                  height="179"
                  className="responsive-img"/>
              <p className="promo-caption">Deeper dive on keywords</p>
              <p>Optimize your pages based on keyword frequency, density,
                low-hanging fruit. One-click filter to find question related
                content ideas i.e. who, what, where why keywords
              </p>
            </div>
            <div className="col l4 m4 s12">
              <img src={`${publicUrl}assets/page-serp-preview.png`}
                  alt="serp preview tool"
                  width="305"
                  height="179"
                  className="responsive-img" />
              <p className="promo-caption">SERP preview</p>
              <p>
                Modify your title, meta descriptions and h1's with a convenient
                add-to-clipboard button to paste into your code, spreadsheet or
                document. Also with pixel and character counts.
              </p>
            </div>
          </div>

          <div className="home__footer center col s12">
            <a href="mailto:email@anthonydeguzman.com">Contact</a>
            {' '} &middot; {' '}
            <span
              className="tooltipped"
              data-position="top"
              data-delay="50"
              data-tooltip="We do not sell your data in any shape or form. No site data is ever stored on PageOutil.com">
              Data Disclaimer
            </span>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ auth, error }) {
  return { auth, error };
}

export default withRouter(connect(mapStateToProps, actions)(Home));



// WEBPACK FOOTER //
// ./src/components/Home.js